export const ASSET_TYPE = {
    MARKETING: 'marketing',
    PRESENTATION_VIDEO: 'presentationVideo',
    PREVIEW_IMAGE: 'companyPreviewImage',
  };